import "babel-polyfill";

import * as React from "react";
import { AppRouter } from "./components/app-router";
import { context } from "../context/context";
import { i18nManagerFrontOffice } from "./i18n/i18n-manager-front-office";
import { useStrict } from "mobx";
import { createRoot, Root } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import { GetEnvironment, IsPublicEnvironment } from "../helpers/environment";

export const AppContainerId = "app-content";

class AppInitializer {
  private root: Root;

  public async initAsync() {
    useStrict(true);

    document.addEventListener("DOMContentLoaded", async () => await this.firstRenderApp());

    if (window.__CONFIG__.SentryDsn) {
      Sentry.init({
        dsn: window.__CONFIG__.SentryDsn,
        tunnel: "/api/v3/frontend/sentry/desktop",
        integrations: [browserTracingIntegration],
        tracesSampleRate: IsPublicEnvironment() ? 0.3 : 1.0,
        environment: GetEnvironment(),
      });
    }
  }

  private async firstRenderApp() {
    await i18nManagerFrontOffice.init();
    context.applicationName = "Front-Office";
    context.initUserSession();
    await context.initAuthenticatedContextAsync();
    this.bootstrap();
    this.renderApp();
  }

  private bootstrap() {
    const container = document.getElementById(AppContainerId)!;

    this.root = createRoot(container);
  }

  public renderApp() {
    this.root.render(React.createElement(AppRouter));
  }
}

const initializer = new AppInitializer();
initializer.initAsync();
